export default "__VITE_ASSET__COpfD30Q__"